/**
 * The following type definitions are based on Userpilot's javascript API reference
 * https://docs.userpilot.com/article/61-javascript-api
 */
interface UserpilotEventDataRaw {
  id: number;
  token: string;
  [key: string]: string | number;
}

interface UserpilotGlobal {
  identify: (userId: string, properties?: Record<string, string>) => void;
  destroy: () => void;
  reload: (url?: { url: string }) => void;
  track: (event: string, properties?: Record<string, string>) => void;
  trigger: (contentId: string) => void;
  on: (event: string, cb: (data: UserpilotEventDataRaw) => void) => void;
  off: (event: string) => void;
  once: (event: string, cb: (data: UserpilotEventDataRaw) => void) => void;
}

/**
 * getUserpilotGlobal: Returns the global userpilot instance, which is defined on the Window.
 *
 * Note: this function is intended for use within the @/features/userpilot module only.
 * Application access must use the useUserpilot hook.
 */
export function getUserpilotGlobal() {
  if (
    RUNTIME_ENV !== 'browser' ||
    typeof window === 'undefined' ||
    typeof window['userpilot'] === 'undefined'
  ) {
    return undefined;
  }

  return window['userpilot'] as UserpilotGlobal;
}
